import { Location } from '@angular/common';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslatesService } from '@shared/translates';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedModalComponent } from 'app/components/shared-modal/shared-modal.component';
import { BlogService } from '../blog.service';
import { Article } from '../blog.type';
import { AuthService } from '@shared/services/auth.service';
import { TinyReplacerService } from '@shared/services/tinyReplacer.service';
import { SEOService } from '@shared/services/seo.service';
import { ExtFormService } from '@shared/services/extForm.service';
import { TipModalComponent } from 'app/components/tip-modal/tip-modal.component';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
})
export class ArticleComponent implements OnInit, AfterViewInit {
  slug: string;
  slugId: string;
  article: Article;
  public relatedPost: Article[];

  public isClub3 = false;

  hasPrevNav = false;

  constructor(
    private blogService: BlogService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private readonly seoService: SEOService,
    private modalService: NgbModal,
    private route: Router,
    private _translatesService: TranslatesService,
    private authService: AuthService,
    private tinyReplacerService: TinyReplacerService,
    private extFormService: ExtFormService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.slug = params.slug;
      this.slugId = params.id;

      const router = this.route.url.split('/');
      if (this._translatesService.getAvailableLangs().includes(router[1]) && router[1] !== this._translatesService.getCurrentLang()) {
        this._translatesService.changeLang(router[1]).subscribe();
      }
    });

    const currentNav = this.route.getCurrentNavigation();
    if (currentNav) {
      this.hasPrevNav = true;
    }

    this.route.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };

    this.route.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.route.navigated = false;
        // if you need to scroll back to top, here is the right place
        document.body.scrollTop = 0;
      }
    });
  }

  async ngOnInit(): Promise<void> {}

  timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public async showShareModal(article: Article) {
    const modalRef = this.modalService.open(SharedModalComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'blog-share'
    });
    const lang = this._translatesService.getCurrentLang();

    const urls = window.location.href.split(`/${lang}/`);
    const url = `${urls[0]}/${lang}/article/${article.slugId}/${article.slug}`;

    modalRef.componentInstance.url = window.location.href;
    modalRef.componentInstance.browserTitle = article.browserTitle;
    modalRef.componentInstance.metaDescription = article.metaDescription;
    modalRef.componentInstance.thumbnail = article.thumbnail;
    modalRef.componentInstance.type = 'blog';
  }

  goToArticle(article: Article) {
    const route = '/' + this._translatesService.getCurrentLang() + '/article';
    this.route.navigate([route, article.slugId, article.slug]);
  }

  async ngAfterViewInit() {
    this.article = await this.blogService.getArticleBySlugId(this.slugId);
    if (this.article.id === 'not ready yet') {
      if (!localStorage.getItem('adminToken')) {
        const mail = prompt('mail', '');
        const pass = prompt('pass', '');
        const retAdminLogin = await this.authService.adminLogin(mail, pass);
      }
      this.article = await this.blogService.getArticleBySlugId(this.slugId, true);
    }
    this.location.go(this._translatesService.getCurrentLang() + '/article/' + this.article.slugId + '/' + this.article.slug);
    this.relatedPost = await this.blogService.getRelatedPost(this.article.id);
    this.article.html = this.article.html.split('<p').join('<p class="police"');
    this.article.html = this.article.html
      .split('<h1')
      .join('<h1 class="police"');
    this.article.html = this.article.html
      .split('<h2')
      .join('<h2 class="police"');
    this.article.html = this.article.html
      .split('<h3')
      .join('<h3 class="police"');

    this.article.html = await this.tinyReplacerService.replaceTinyTxt(this.article.html);

    this.seoService.updateDescription(this.article.metaDescription);
    this.seoService.updateTitle(this.article.title);
    this.seoService.updateOgImage(this.article.imageCover);

    await this.timeout(2000);
    this.activatedRoute.fragment.subscribe(fragment => {
      this.scrollToAnchor(fragment);
    });
  }

    /**
   * Scroll to anchor
   *
   * @param {string} location Element id
   * @param {string} wait     Wait time in milliseconds
   */
  public scrollToAnchor(location: string, wait = 0): void {
    const element = document.querySelector('#' + location);
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
      }, wait);
    }
  }

  updateUserLevel() {
    if (!this.authService.isAuthenticated() ||
        this.authService.getUserType() === 'club' && this.authService.getUserLevel() !== 3) {
      this.isClub3 = false;
    } else {
      this.isClub3 = true;
    }
  }

  connection() {
    if (!this.isClub3) {
      this.extFormService.clubConnect();
    }
  }

  tip() {
    const modalRef = this.modalService.open(TipModalComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'blog-tip'
    });
  }
}
